import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  applyChatNavigationAction,
  readNavigationActionsFromMetadata,
  type ChatNavigationAction,
} from './chatNavigationActions';
import styles from './ChatPanel.module.css';

export interface ChatPanelNavigationActionsProps {
  metadata?: Record<string, unknown>;
}

const ChatPanelNavigationActionButtons: React.FC<{ actions: ChatNavigationAction[] }> = ({
  actions,
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.navigationActions} data-testid="chat-navigation-actions">
      {actions.map((action, index) => (
        <Button
          key={`${action.type}-${action.artifactItemRef ?? index}`}
          type="link"
          size="small"
          onClick={() => applyChatNavigationAction(action, navigate)}
        >
          {action.label}
        </Button>
      ))}
    </div>
  );
};

export const ChatPanelNavigationActions: React.FC<ChatPanelNavigationActionsProps> = ({
  metadata,
}) => {
  const actions = readNavigationActionsFromMetadata(metadata);
  if (actions.length === 0) return null;
  return <ChatPanelNavigationActionButtons actions={actions} />;
};
